module.exports = __webpack_public_path__ + "static/antifungal_effect_of_silver_nanoparticles_on_dermatophytes-0ccda376e286ab8d522f1bab4850a786.pdf";